import { AutogenModelLocationDetentionHistory, AutogenRowLocationDetentionHistory } from "./autogen/AutogenModelLocationDetentionHistory";

export class ModelLocationDetentionHistory extends AutogenModelLocationDetentionHistory<RowLocationDetentionHistory> {
    constructor() {
        super(RowLocationDetentionHistory);
    }
}

export class RowLocationDetentionHistory extends AutogenRowLocationDetentionHistory {
}